
import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { 
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface ErrorAlertProps {
  hasErrors: boolean;
  onRetryClick: () => void;
}

const ErrorAlert = ({ hasErrors, onRetryClick }: ErrorAlertProps) => {
  if (!hasErrors) {
    return null;
  }
  
  return (
    <Alert variant="warning" className="mb-6">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Some analytics data couldn't be loaded</AlertTitle>
      <AlertDescription>
        <p>There was an error loading some of the analytics data. You can try refreshing the data.</p>
        <Button 
          variant="outline" 
          size="sm" 
          className="mt-2" 
          onClick={onRetryClick}
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Retry Loading Data
        </Button>
      </AlertDescription>
    </Alert>
  );
};

export default ErrorAlert;
